import comp from "./MultipleAttachmentsSlider";
export default comp;
